// LootjesBeheer.jsx — /lootjes/beheer/:groepToken
// Organisator ziet wie er al in zit en trekt de lootjes

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Events } from "../analytics";

const BUDGET_LABELS = { "15": "tot €15", "30": "€15–€30", "60": "€30–€60", "100": "€60–€100", "100plus": "€100+" };

export default function LootjesBeheer() {
  const { groepToken } = useParams();
  const [groep, setGroep] = useState(null);
  const [fout, setFout] = useState(null);
  const [laden, setLaden] = useState(true);
  const [trekken, setTrekken] = useState(false);
  const [getrokken, setGetrokken] = useState(false);
  const [lootjes, setLootjes] = useState([]);
  const [gekopieerd, setGekopieerd] = useState(null);

  useEffect(() => {
    try {
      const data = JSON.parse(atob(groepToken.replace(/-/g, "+").replace(/_/g, "/")));
      setGroep(data);
      if (data.getrokken) setGetrokken(true);
    } catch {
      setFout("Ongeldige beheerderslink.");
    } finally {
      setLaden(false);
    }
  }, [groepToken]);

  async function trekkLootjes() {
    if (trekken) return;
    if (groep?.deelnemers?.length < 3) {
      alert("Je hebt minimaal 3 deelnemers nodig om lootjes te trekken.");
      return;
    }
    if (!window.confirm(`Lootjes trekken voor ${groep?.deelnemers?.length} deelnemers? Dit kan niet ongedaan worden gemaakt.`)) return;
    setTrekken(true);
    try {
      const res = await fetch("/.netlify/functions/lootjes?trek=1", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ groepToken }),
      });
      const json = await res.json();
      if (json.error) throw new Error(json.error);
      setLootjes(json.persoonlijkeLootjes);
      setGetrokken(true);
      Events.track("Lootjes getrokken", { aantalDeelnemers: json.aantalDeelnemers });
    } catch (e) {
      alert(e.message || "Er ging iets mis.");
    } finally {
      setTrekken(false);
    }
  }

  const kopieer = (tekst, id) => {
    navigator.clipboard.writeText(tekst).then(() => {
      setGekopieerd(id);
      setTimeout(() => setGekopieerd(null), 2500);
    });
  };

  if (laden) return (
    <main className="main">
      <div className="card fi" style={{ textAlign: "center", padding: 40 }}>
        <div className="ai-spinner" style={{ margin: "0 auto 16px" }} />
      </div>
    </main>
  );

  if (fout) return (
    <main className="main">
      <div className="card fi" style={{ textAlign: "center" }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>😕</div>
        <p style={{ color: "#8A7B73" }}>{fout}</p>
      </div>
    </main>
  );

  const deelUrl = `https://app.givn.to/lootjes/doe-mee/${groepToken}`;

  return (
    <main className="main">
      <div className="card fi">
        {/* Header */}
        <div style={{
          background: "linear-gradient(135deg,#3D5A4C,#4a6b5a)",
          borderRadius: 20, padding: 20, marginBottom: 22,
        }}>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.6)", marginBottom: 4 }}>Lootjesgroep</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "white", marginBottom: 4 }}>{groep?.naam}</div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.75)" }}>
            {BUDGET_LABELS[groep?.budget]} · {groep?.deelnemers?.length || 0} deelnemers
          </div>
        </div>

        {!getrokken && (
          <>
            {/* Deellink */}
            <div className="flabel">Deellink — stuur naar groep</div>
            <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
              <div style={{
                flex: 1, background: "#FDEEE8", border: "1px solid #EDE3D9",
                borderRadius: 10, padding: "10px 12px", fontSize: 12,
                color: "#8A7B73", wordBreak: "break-all", fontFamily: "monospace",
              }}>
                {deelUrl}
              </div>
              <button onClick={() => kopieer(deelUrl, "deel")} style={{
                flexShrink: 0, padding: "10px 14px", borderRadius: 10,
                border: "1.5px solid #EDE3D9",
                background: gekopieerd === "deel" ? "#EDF3EF" : "white",
                color: gekopieerd === "deel" ? "#3D5A4C" : "#2C2420",
                fontWeight: 700, fontSize: 12, cursor: "pointer",
                fontFamily: "'DM Sans',sans-serif",
              }}>
                {gekopieerd === "deel" ? "✓" : "📋"}
              </button>
            </div>

            {/* Deelnemerslijst */}
            <div className="flabel">Deelnemers ({groep?.deelnemers?.length})</div>
            <div style={{ marginBottom: 20 }}>
              {groep?.deelnemers?.map((d, i) => (
                <div key={d.id} style={{
                  display: "flex", alignItems: "center", gap: 12,
                  padding: "10px 0", borderBottom: i < groep.deelnemers.length - 1 ? "1px solid #EDE3D9" : "none",
                }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: "50%",
                    background: "#FDEEE8", display: "flex", alignItems: "center",
                    justifyContent: "center", fontSize: 16, flexShrink: 0,
                  }}>
                    {d.isOrganisator ? "👑" : "🧑"}
                  </div>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#2C2420" }}>
                      {d.naam} {d.isOrganisator && <span style={{ fontSize: 11, color: "#8A7B73" }}>(organisator)</span>}
                    </div>
                    {d.interesses?.length > 0 && (
                      <div style={{ fontSize: 12, color: "#8A7B73" }}>
                        {d.interesses.join(", ")}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Trek knop */}
            <button className={"bfull bn " + (groep?.deelnemers?.length >= 3 ? "gr" : "off")}
              onClick={trekkLootjes} disabled={trekken}>
              {trekken ? "Lootjes trekken…" : `🎲 Trek de lootjes (${groep?.deelnemers?.length} deelnemers)`}
            </button>
            {groep?.deelnemers?.length < 3 && (
              <p style={{ fontSize: 12, color: "#8A7B73", textAlign: "center", marginTop: 8 }}>
                Minimaal 3 deelnemers nodig. Nog {3 - groep.deelnemers.length} persoon/personen.
              </p>
            )}
          </>
        )}

        {/* Na het trekken: persoonlijke links */}
        {getrokken && lootjes.length > 0 && (
          <>
            <div style={{
              background: "#FDEEE8", border: "1.5px solid #EDE3D9",
              borderRadius: 14, padding: "14px 16px", marginBottom: 20,
            }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#2C2420", marginBottom: 4 }}>
                🎉 Lootjes getrokken!
              </div>
              <div style={{ fontSize: 13, color: "#8A7B73", lineHeight: 1.6 }}>
                Stuur hieronder elke deelnemer zijn persoonlijke link. Ze zien dan hun lootje én krijgen direct cadeausuggesties.
              </div>
            </div>

            {lootjes.map(l => (
              <div key={l.deelnemerId} style={{
                border: "1.5px solid #EDE3D9", borderRadius: 14,
                padding: "14px 16px", marginBottom: 10,
              }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#2C2420", marginBottom: 8 }}>
                  {l.deelnemerNaam}
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <a href={"https://api.whatsapp.com/send?text=" + encodeURIComponent(
                    `Hey ${l.deelnemerNaam}! 🎁 De lootjes zijn getrokken.\n\nKijk hier wie jij hebt en krijg direct cadeausuggesties:\n${`https://app.givn.to/lootjes/jouw-lootje/${l.lootjeToken}`}`
                  )}
                    target="_blank" rel="noopener noreferrer"
                    style={{
                      flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
                      gap: 6, padding: "9px 8px", borderRadius: 10,
                      background: "#25D366", color: "white",
                      fontWeight: 700, fontSize: 12, textDecoration: "none",
                      fontFamily: "'DM Sans',sans-serif",
                    }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="white">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                    WhatsApp
                  </a>
                  <button onClick={() => kopieer(`https://app.givn.to/lootjes/jouw-lootje/${l.lootjeToken}`, l.deelnemerId)}
                    style={{
                      flex: 1, padding: "9px 8px", borderRadius: 10,
                      border: "1.5px solid #EDE3D9",
                      background: gekopieerd === l.deelnemerId ? "#EDF3EF" : "white",
                      color: gekopieerd === l.deelnemerId ? "#3D5A4C" : "#2C2420",
                      fontWeight: 700, fontSize: 12, cursor: "pointer",
                      fontFamily: "'DM Sans',sans-serif",
                    }}>
                    {gekopieerd === l.deelnemerId ? "✓ Gekopieerd" : "📋 Link"}
                  </button>
                </div>
              </div>
            ))}
          </>
        )}

        {getrokken && lootjes.length === 0 && (
          <div style={{ textAlign: "center", padding: 20, color: "#8A7B73", fontSize: 14 }}>
            De lootjes zijn al eerder getrokken. Deelnemers hebben hun persoonlijke link ontvangen.
          </div>
        )}
      </div>
    </main>
  );
}
